import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {PriceValidator} from '../../shared/validators/valid-price.directive';

import {PriceFieldComponent} from './price-field.component';

@NgModule({
    declarations: [
        PriceFieldComponent, PriceValidator
    ],
    imports: [
        RouterModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [ PriceFieldComponent ]
})

export class PriceFieldModule {}
